import script from "./CreateWebsitePrompt.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateWebsitePrompt.vue?vue&type=script&setup=true&lang=js"

import "./CreateWebsitePrompt.vue?vue&type=style&index=0&id=2a27e520&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a27e520"]])

export default __exports__